<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="100" label-position="right"
                                  ref="form">
                                <FormItem :label="t.config.name" prop="name">
                                    <Input v-model="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.config.typeName" prop="type">
                                    <Input v-model="formItem.typeName" readonly></Input>
                                </FormItem>
                                <div v-show="formItem.type === '0'">
                                    <FormItem :label="t.config.key1" prop="type">
                                        <Input v-model="formItem.key1" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value1" prop="type">
                                        <Input v-model="formItem.value1" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key2" prop="type">
                                        <Input v-model="formItem.key2" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value2" prop="type">
                                        <Input v-model="formItem.value2" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key3" prop="type">
                                        <Input v-model="formItem.key3" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value3" prop="type">
                                        <Input v-model="formItem.value3" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key4" prop="type">
                                        <Input v-model="formItem.key4" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value4" prop="type">
                                        <Input v-model="formItem.value4" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key5" prop="type">
                                        <Input v-model="formItem.key5" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value5" prop="type">
                                        <Input v-model="formItem.value5" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key6" prop="type">
                                        <Input v-model="formItem.key6" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value6" prop="type">
                                        <Input v-model="formItem.value6" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key7" prop="type">
                                        <Input v-model="formItem.key7" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value7" prop="type">
                                        <Input v-model="formItem.value7" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key8" prop="type">
                                        <Input v-model="formItem.key8" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value8" prop="type">
                                        <Input v-model="formItem.value8" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key9" prop="type">
                                        <Input v-model="formItem.key9" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value9" prop="type">
                                        <Input v-model="formItem.value9" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.key10" prop="type">
                                        <Input v-model="formItem.key10" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.config.value10" prop="type">
                                        <Input v-model="formItem.value10" readonly></Input>
                                    </FormItem>
                                </div>
                                <div v-show="formItem.type === '1'">
                                    <FormItem :label="t.config.body">
                                        <tinymce id="id1" v-model="formItem.body" :toolbar1="toolbar1"
                                                 :other_options="other_options"></tinymce>
                                    </FormItem>
                                </div>
                                <!--<FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>-->
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import { edit, getConfigInfo } from '@/api/config';

export default {
    name: 'sys_manage_config_edit',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            baseURL: BaseUrl.dataUrl + '/image/scale/',
            formItemBk: {},
            formItem: {
                id: '',
                type: '',
                typeName: '',
                name: '',
                key1: '',
                value1: '',
                key2: '',
                value2: '',
                key3: '',
                value3: '',
                key4: '',
                value4: '',
                key5: '',
                value5: '',
                key6: '',
                value6: '',
                key7: '',
                value7: '',
                key8: '',
                value8: '',
                key9: '',
                value9: '',
                key10: '',
                value10: '',
                body: '',
            },
            ruleValidate: {},
            typeFlg: '0',
            loading: false,
            toolbar1:
                'newnote print preview code | undo redo | insert | styleselect | fontsizeselect | fontselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons media codesample',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
                images_upload_handler: function(blobInfo, success, failure) {
                    let param = new FormData(); //创建form对象
                    param.append('image', blobInfo.blob(), blobInfo.filename()); //通过append向form对象添加数据
                    axios
                        .post(BaseUrl.dataUrl + '/image/scale/', param)
                        .then(response => success(BaseUrl.Url + response.data.url));
                },
            },
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    let configDto = {};
                    configDto.name = this.formItem.name;
                    configDto.type = this.formItem.type;
                    if (configDto.type === '1') {
                        configDto.key1 = this.formItem.key1;
                        configDto.value1 = this.formItem.value1;
                        configDto.key2 = this.formItem.key2;
                        configDto.value2 = this.formItem.value2;
                        configDto.key3 = this.formItem.key3;
                        configDto.value3 = this.formItem.value3;
                        configDto.key4 = this.formItem.key4;
                        configDto.value4 = this.formItem.value4;
                        configDto.key5 = this.formItem.key5;
                        configDto.value5 = this.formItem.value5;
                        configDto.key6 = this.formItem.key6;
                        configDto.value6 = this.formItem.value6;
                        configDto.key7 = this.formItem.key7;
                        configDto.value7 = this.formItem.value7;
                        configDto.key8 = this.formItem.key8;
                        configDto.value8 = this.formItem.value8;
                        configDto.key9 = this.formItem.key9;
                        configDto.value9 = this.formItem.value9;
                        configDto.key10 = this.formItem.key10;
                        configDto.value10 = this.formItem.value10;

                    } else {
                        configDto.body = this.formItem.body;
                    }
                    await edit(this.$route.params.id, configDto);
                    Object.assign(this.formItemBk, this.formItem);
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
        },
        async init() {
            const configInfo = await getConfigInfo(this.$route.params.id);
            if (configInfo.config != null) {
                this.formItem = configInfo.config;
                this.formItem.typeName =
                    this.formItem.type === '0' ? this.t.config.typeImage : this.t.config.typeContent;
                this.formItem.body = this.formItem.body === null ? '' : this.formItem.body;
                Object.assign(this.formItemBk, configInfo.config);
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
